import { useNavigate } from "react-router-dom";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import ClassAppointmentExitPopup from "../PopupModal/EndCallModal";
import { memo, useState } from "react";
import Loader from "../Sub_components/Loader";
import { extractInitials } from "../utils/GenericFunction";

function WaitingForHostToJoin() {
  const { eventType, userNameHost, classesName, photoHostUrl, call, role } =
    useLiveStreamAppContext();
  const navigate = useNavigate();

  const [exitModalShow, setExitModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const EndCallButtonTextHead = () => {
    if (role === "Presenter") {
      return eventType === 1 ? "End Appointment" : "End Class";
    }
    if (role === "Attendee") {
      return eventType === 1 ? "Leave Appointment" : "Leave Class";
    }
    return "";
  };

  const getExitMessage = () => {
    if (role === "Presenter") {
      return eventType === 1
        ? "Are you sure you want to end the Appointment? This will end your live stream and attendee will be logged out."
        : "Are you sure you want to end the class? This will end your live stream and all attendees will be logged out.";
    }

    if (role === "Attendee") {
      return eventType === 1
        ? "Are you sure you want to leave the appointment?"
        : "Are you sure you want to leave the class?";
    }
    return "Are you sure you want to exit the meeting?";
  };

  const handleEndCallNormal = async () => {
    await endCall();
    if (role === "Attendee") {
      const currentPath = window.location.pathname;
      const newPath = currentPath.replace("/meeting", "/feedback");
      navigate(newPath + window.location.search);
    }
  };

  // --- Function to handle call hang-up and cookie deletion
  const endCall = async () => {
    setIsLoading(true);

    const timeoutId = setTimeout(() => {
      call.hangUp({ forEveryone: true });
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timeoutId);
  };

  function handleEndCall() {
    return handleEndCallNormal;
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="player-gray-bg WaitingAteendeeScreen ">
        <div
          id="dvWaitingScreen"
          className="attendee-waiting-room"
          style={{ display: "flex" }}
        >
          <div className="attendee-waiting-room-wrraper">
            <div
              className="avatar lazylivestreamimg loaded"
              id="dvWaitingScreenProviderImage"
              style={{
                display: "inline-block",
                backgroundImage: photoHostUrl ? `url(${photoHostUrl})` : "",
              }}
            >
              <div
                id="dvWaitingScreenProviderInitial"
                className="initialspusername"
                style={{ display: photoHostUrl ? "none" : "block" }}
              >
                {extractInitials(userNameHost)}
              </div>
            </div>
            <div id="dvWaitingScreenClassName" className="disconnect-title">
              {classesName}
            </div>
            <div
              id="dvWaitingScreenProviderName"
              className="dvWaitingScreenProviderName"
            >
              {userNameHost}
            </div>
            <p id="dvWaitingScreenMessage" className="disconnect-txt">
              {eventType === 1
                ? "Waiting for host to start appointment."
                : "Waiting for instructor to start class."}
            </p>
          </div>
          <div
            id="divHostWaitingAttendeeViewChange"
            style={{ display: "none" }}
            className="change-view hot-slider-view hide-on-mobileOnly attGalleryTooltip"
          >
            <i className="icon font-awesome-light-pro va-border-all "></i>
            <span id="viewTypeAttendee" className="tooltiptext">
              Gallery View
            </span>
          </div>
        </div>
      </div>

      <ClassAppointmentExitPopup
        show={exitModalShow}
        onHide={() => setExitModalShow(false)}
        handleEndCall={handleEndCall()}
        message={getExitMessage()}
        buttontext={EndCallButtonTextHead()}
        headtext={EndCallButtonTextHead()}
      />
    </>
  );
}
export default memo(WaitingForHostToJoin);
